<div class="dvb-draggable-element"
     ng-attr-draggable="{{vm.isDraggable}}"
     data-id="{{vm.id}}">
    <ng-transclude></ng-transclude>
</div>
